import { createApp } from 'vue';
import VueLadda     from 'vue3-ladda';

import { pinia }  from 'store/store';
import i18n       from 'cfg/i18n';
import directives from 'cfg/Directives';
import BModal     from 'Common/Modal/BModal.vue';

export default function mountApp(config, selector) {
  const app = createApp(config);

  if (config.translationDomain) {
    app.provide('translationDomain', config.translationDomain);
  }

  app.component('vue-ladda', VueLadda);
  app.component('bmodal', BModal);

  directives.forEach(([name, definition])=> app.directive(name, definition));

  return app
    .use(pinia)
    .use(i18n)
    .mount(selector);
}
